import React, { useEffect, useState } from "react";
import { User } from "../../../../imsdk/db/t_user";
import { TopicUserListRender } from "../TopicUsers";
import { useChatStore } from "../../../store/ChatStore";
import { GroupMember } from "../../../../imsdk/db/t_group_member";
import { navigateToUserInfo } from "../chat-helper";
import { Str_GroupMembers } from "../../../language/string_res";
import * as ImSdk from "../../../../imsdk/api";
import { MainNavProps } from "../../navigation/main/MainParamList";
import { ScreenCloseModal } from "../../../components/ScreenModal";

export const GroupUserScreen = ({
  navigation,
  route,
}: MainNavProps<"GroupUserList">) => {
  const { tid, isSearch, isAdmin } = route.params;
  const [users, setUsers] = useState<User[]>([]);
  const { chatState } = useChatStore();
  const { group } = chatState.curTopicWithSummary;
  if (!tid) {
    return <></>;
  }
  useEffect(() => {
    ImSdk.getInstance()
      .GetGroupDetail(tid, true)
      .then((r) => {
        const members = r.members || chatState.curTopicWithSummary.users;
        if (members && members.length > 0) {
          setUsers(members as any as User[]);
        }
      });
  }, [group]);

  function pageToUserDetail(item: User | GroupMember) {
    if (isSearch) {
      navigation.navigate("QuickSearchMsgScreen", {
        tid: tid,
        sender: item.uid,
      });
    } else {
      if (
        chatState.curTopicWithSummary.group?.group_allow_member_visit !== "1" &&
        !(isAdmin === true)
      ) {
        return;
      }
      navigation.navigate("ContactInfoModeal", { current: item });
    }
  }

  return (
    <TopicUserListRender
      title={Str_GroupMembers}
      users={users}
      onClick={pageToUserDetail}
    />
  );
};
